import React from 'react';
import { Col, Row, Form, FormGroup, InputGroup, Input, Button } from 'reactstrap';
import {DatePicker} from 'reactstrap-date-picker';

const SearchXt = props => {
    
        return (
            <>
            <div className="container-lg mx-2">
            <Form>
                <Col className="row-cols-lg-auto g-3 align-items-center pb-4">
                <InputGroup>
                <FormGroup>
                    <Input type="select" name="select" id="busqueda" className="btn btn-primary text-xtorage" style={{dropSearch, backgroundColor: "#766CB2", borderColor: "#766CB2"}}>
                        <option>Parques</option>
                        <option>Hoteles</option>
                        <option>Tours</option>
                        <option>Redes sociales</option>
                    </Input>
                </FormGroup>
                    <Input placeholder='Ejemplo: XC-mockup-about' style={dropInput} className="text-xtorage" />
                    <Button className="ml-2 text-xtorage" style={dropFind}>
                    <i className="fa fa-search mr-2" aria-hidden="true"></i>
                    Buscar
                    </Button>
                </InputGroup>
                </Col>
                </Form>
            </div>

            <Row className="d-flex p-2 mb-2 justify-content-center container-lg">
           
                <Col className="">
                    
                    <h6 className="text-uppercase text-xtorage">Categorias</h6>
                    <FormGroup>
                    <Input type="select" name="categorias" id="categorias" className="btn btn-primary text-xtorage" style={{backgroundColor: "#766CB2", borderColor: "#766CB2"}} >
                        <option>Seleccion</option>
                        <option>Logotipos</option>
                        <option>Fotos</option>
                        <option>Mockups</option>
                        <option>Plantillas</option>
                        <option>Editables</option>
                        <option>Manuales</option>
                        <option>Reconocimientos</option>
                    </Input>
                </FormGroup>
                </Col>

                <Col className="">
                    <h6 className="text-uppercase text-xtorage">Tags</h6>
                    <FormGroup>
                    <Input type="select" name="tags" id="tags" className="btn btn-primary text-xtorage" style={{backgroundColor: "#766CB2", borderColor: "#766CB2"}} >
                        <option>Seleccion</option>
                        <option>#DID</option>
                        <option>#SEO</option>
                        <option>#mockup</option>
                        <option>#BlackFriday</option>
                    </Input>
                </FormGroup>
                </Col>

                <Col className="">
                    
                    <h6 className="text-uppercase text-xtorage">Campañas</h6>
                    <FormGroup>
                    <Input type="select" name="campañas" id="campañas" className="btn btn-primary text-xtorage" style={{backgroundColor: "#766CB2", borderColor: "#766CB2"}}>
                        <option>Seleccion</option>
                        <option>Xpring Break</option>
                        <option>Black Friday</option>
                        <option>Cyber Monday</option>
                        <option>Buen Fin 2024</option>
                    </Input>
                </FormGroup>
                </Col>

                <Col className="">
                    
                    <h6 className="text-uppercase text-xtorage">Formato</h6>
                    <FormGroup>
                    <Input type="select" name="formato" id="formato" className="btn btn-primary text-xtorage" style={{backgroundColor: "#766CB2", borderColor: "#766CB2"}}>
                        <option>Seleccion</option>
                        <option>SVG</option>
                        <option>PNG</option>
                        <option>PDF</option>
                        <option>JPG/JPEG</option>
                        <option>GIF</option>
                        <option>XD</option>
                        <option>AI</option>
                        <option>PSD</option>
                    </Input>
                </FormGroup>
                </Col>

                <Col className="">
                    
                    <h6 className="text-uppercase text-xtorage">Fecha de creación</h6>
                    <FormGroup>
                    <DatePicker defaultValue="01/01/2023" name="fecha" id="fecha" className="btn btn-primary text-xtorage" style={{backgroundColor: "#766CB2", borderColor: "#766CB2"}} />
                       
                </FormGroup>
                </Col>
 
            </Row>
            
            </>
        );
}

const dropSearch = {
    fontSize: 14,
    color: "#fff",
    textAlign: "center",
    width: "8rem",
    height:"2rem",
    appearance: "none",
    cursor:"pointer",
}

const dropFind = {
    fontSize: 14,
    color: "#fff",
    textAlign: "center",
    width: "8rem",
    height:"2rem",
    appearance: "none",
    backgroundColor: "#766CB2",
    border: "none"
}

const dropInput = {
    fontSize: 16,
    color: "#3d3d3d",
    textAlign: "left",
    width: "8rem",
    height:"2.2rem",
}

const datePicker = {
    fontSize: 14,
    color: "#fff",
    textAlign: "center",
    width: "8rem",
    height:"2rem",
    appearance: "none",
    backgroundColor: "#766CB2",
    border: "none"
}


export default SearchXt;
